import { gql } from '@apollo/client';

/**
 * Staff Shopify Orders — read-only order lookup for staff without a Shopify admin seat.
 *
 * Paging is CURSOR-based (`endCursor` → `after`), unlike the offset paging the Order Devices queue
 * uses. Shopify connections have no "skip N", so a page number cannot be reconstructed — the caller
 * keeps the cursors it has seen.
 */

const ORDER_ROW_FIELDS = `
  id
  name
  createdAt
  totalAmount
  totalCurrency
  itemCount
  channel
  displayFulfillmentStatus
  displayFinancialStatus
  shipToName
  customerEmail
  deliveryMethod
  trackingNumber
  trackingUrl
`;

export const STAFF_SHOPIFY_ORDERS = gql`
  query StaffShopifyOrders($input: ShopifyOrderSearchInput) {
    staffShopifyOrders(input: $input) {
      nodes { ${ORDER_ROW_FIELDS} }
      hasNextPage
      endCursor
    }
  }
`;

/**
 * Full detail for the drawer. `json` is Shopify's order payload, unmodelled on purpose — the drawer
 * renders it, nothing filters or sorts on it. See ShopifyOrderDetail in the API for why.
 */
export const STAFF_SHOPIFY_ORDER = gql`
  query StaffShopifyOrder($id: String!) {
    staffShopifyOrder(id: $id) {
      id
      json
    }
  }
`;
